import { useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

const PRESENTATION = {
  id: "1230583733",
  hash: "2754f555b8",
  title: "The full overview — every detail, start to finish",
  duration: "21:59",
  thumb: "https://i.vimeocdn.com/video/2205515805-5d9af5892d00c2898d6974344d9201b30d0951cb9743706cac0a905b7c5eeb3e-d_1280x720?region=us",
};

const STORIES = [
  { id: "1216731630", hash: "8c63c6fbe5", title: "Kerri's business story", duration: "0:57", thumb: "https://i.vimeocdn.com/video/2188241075-866996fe65a8f3aa53a78f40b334a083dac4bdd74404f5eeaf91cfbdb5f26bd3-d_360x640?region=us" },
  { id: "1216729459", hash: "02d2f7463e", title: "Jacki's business story", duration: "0:38", thumb: "https://i.vimeocdn.com/video/2188238186-2bcedbcb0d04c2da8e29e1be69ae23fd8ea094f7c6abb14dbad40c54015a2a1e-d_360x640?region=us" },
  { id: "1215851098", hash: "721832f7bb", title: "Benson's business story", duration: "1:15", thumb: "https://i.vimeocdn.com/video/2187130342-eb50df7e1372bd218d57dfe1cecd6218b6b47c714615ec98934acec63c1ee638-d_360x640?region=us" },
  { id: "1215850866", hash: "f1ac6bae88", title: "Trey — why I became an associate", duration: "0:49", thumb: "https://i.vimeocdn.com/video/2187130079-ab16a70f6eff4bc290285418d27a5bda5bc3ea251d6972a924d21af32b15651b-d_360x640?region=us" },
  { id: "1216880163", hash: "534530db81", title: "Angel Wall — business testimonial", duration: "1:42", thumb: "https://i.vimeocdn.com/video/2188425622-6cc7b0ec621da9d812235e500f62b13ff27c1ab322f9e4cbeb39138b39852511-d_360x640?region=us" },
  { id: "1216880162", hash: "78369261c7", title: "Ashley S. — business story", duration: "1:22", thumb: "https://i.vimeocdn.com/video/2188425673-62cb10c9bc023942d58ec4148cb01c0d93719c3ddb529ff3f93b2a174f8841e6-d_360x640?region=us" },
  { id: "1216880380", hash: "df3ceede52", title: "Brittney Black — business testimonial", duration: "1:10", thumb: "https://i.vimeocdn.com/video/2188425669-6ac4298a4106d9e0c670e6f68430efc574e5eea0f193f1351d8299513b283a7f-d_360x640?region=us" },
  { id: "1216880249", hash: "95ef263cdc", title: "Brenda Vien — business story", duration: "1:02", thumb: "https://i.vimeocdn.com/video/2188425336-b556997fc0ea2c35e9a005499d6c104c054a3096b45ebc78e603328bd83075e6-d_360x640?region=us" },
  { id: "1216882544", hash: "c19d4aed41", title: "Barbara Wilson — business story", duration: "1:34", thumb: "https://i.vimeocdn.com/video/2188428349-b9b0497d97565be24d5227eeb49e085a19c62d6fbade8234ff0f58bed7151e35-d_360x640?region=us" },
  { id: "1216882543", hash: "617288192e", title: "Carla Pinto — business testimonial", duration: "4:22", thumb: "https://i.vimeocdn.com/video/2188429514-153275ecf8256c230f437e8c813a9b3aa3ff59e4b855decc99425c7bd10780d3-d_360x640?region=us" },
  { id: "1216881151", hash: "022b482eb1", title: "Yvonne Arriazola — business story", duration: "1:21", thumb: "https://i.vimeocdn.com/video/2188426421-89872424f8ee3f9a45afc5ac4be07d0241c66f6255eab32348896e320c6ae8d5-d_360x640?region=us" },
  { id: "1216881246", hash: "d7bc70fb54", title: "Tara & Daniel Ludovici — opportunity experience", duration: "1:58", thumb: "https://i.vimeocdn.com/video/2188426695-9f7d541f8fcccf62659838088e750901e8868bd1108991b4422f0f4d3370e164-d_360x640?region=us" },
  { id: "1216881476", hash: "31b6fb2c8b", title: "Tammy Wachter — business opportunity", duration: "1:30", thumb: "https://i.vimeocdn.com/video/2188426951-af3374ab00a9f5e3c72f435868a0e958b5210df55ba5bfaeb5a2b018fe594805-d_360x640?region=us" },
  { id: "1216881566", hash: "7b08ce6409", title: "Sandy's business story", duration: "1:43", thumb: "https://i.vimeocdn.com/video/2188427201-9d3c50516844f3f623a1416f068fcdbf683a01ca2d63c4c8ea4c93ac5dc6688f-d_360x640?region=us" },
  { id: "1216881564", hash: "b6babc7b82", title: "Pat Andralliski — business story", duration: "1:52", thumb: "https://i.vimeocdn.com/video/2188427337-0eaeb28476fc4c5c01534b392c8d10443f3fa38493ced156a32359b7b3dc858c-d_360x640?region=us" },
  { id: "1216881983", hash: "798b5fced3", title: "Jasmin Castaneda — business story", duration: "0:56", thumb: "https://i.vimeocdn.com/video/2188428805-5ce272ed27ad88b9acc59180e02cd4a1b92b184ebad0717c108583410af3f398-d_360x640?region=us" },
  { id: "1216882017", hash: "b428369330", title: "Mendy Goodman — business testimony", duration: "1:00", thumb: "https://i.vimeocdn.com/video/2188427812-97b7335f6e2651df2b27eacea0e59adb683eccf0ef34d74595105f2b03ccfca8-d_360x640?region=us" },
  { id: "1216881982", hash: "10d87926c0", title: "Keli Graham Zimmerman — business testimony", duration: "2:00", thumb: "https://i.vimeocdn.com/video/2188427554-bef15d178e326e020dde0d7bf994136065e727a7803babc99de878c3602095b0-d_360x640?region=us" },
  { id: "1216882542", hash: "58763dbeaf", title: "Aaron Aponte — network marketing testimony", duration: "2:04", thumb: "https://i.vimeocdn.com/video/2188428425-2279b4930e1c64debc746cd6b530b17878ba63e4f77666964f7a1d69409b7ced-d_360x640?region=us" },
  { id: "1216882697", hash: "d4ce4f875c", title: "Cindy Summers — business decision", duration: "1:56", thumb: "https://i.vimeocdn.com/video/2188428386-68cc884d426634c75d03bdb5642822bcb8834263593f4dc424661dbb1a4d0af6-d_360x640?region=us" },
  { id: "1216882759", hash: "707fa8a3fb", title: "Dr. Guy & Sheila Danhoff — business testimony", duration: "1:40", thumb: "https://i.vimeocdn.com/video/2188428669-f26239813b986e385f553734d6c9f3f3110d2e8c69b1a16424c5fdb96ef5a35d-d_360x640?region=us" },
  { id: "1216882977", hash: "fd496e96f9", title: "Iesha Cutting — business testimonial", duration: "1:39", thumb: "https://i.vimeocdn.com/video/2188428773-194f9c77476822946192d15172d2e6602a0b1045a7868b0013a3af95425f1aff-d_360x640?region=us" },
  { id: "1216882737", hash: "9be3daac78", title: "Danielle Thompson — business story", duration: "1:12", thumb: "https://i.vimeocdn.com/video/2188429264-0a6eb90968ad07ed103f343250e1fb63f346dd9d2ba229fbcd7691cd492325fd-d_360x640?region=us" },
];

const embedUrl = ({ id, hash }, autoplay) =>
  `https://player.vimeo.com/video/${id}?h=${hash}&title=0&byline=0&portrait=0&dnt=1${autoplay ? "&autoplay=1" : ""}`;

const reveal = {
  hidden: { opacity: 0, y: 36 },
  show: (i) => ({ opacity: 1, y: 0, transition: { delay: i * 0.12, duration: 0.7, ease: EASE } }),
};

function FeaturedPlayer() {
  const [playing, setPlaying] = useState(false);
  return (
    <motion.div
      variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }} custom={2}
      className="relative rounded-3xl overflow-hidden border border-white/10 shadow-2xl shadow-blue-950/50 mb-16"
      data-testid="presentation-player"
    >
      <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
        {playing ? (
          <iframe
            src={embedUrl(PRESENTATION, true)}
            title="Full business overview"
            className="absolute inset-0 w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            data-testid="presentation-iframe"
          />
        ) : (
          <button
            type="button"
            onClick={() => { setPlaying(true); window.__track?.("presentation_play"); }}
            className="group absolute inset-0 w-full h-full text-left"
            data-testid="presentation-play-button"
            aria-label="Play the full overview"
          >
            <img src={PRESENTATION.thumb} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
            <span className="absolute inset-0 bg-gradient-to-t from-[#0B192C]/90 via-[#0B192C]/20 to-transparent" />
            <span className="absolute inset-0 flex items-center justify-center pb-14 sm:pb-0">
              <span className="w-14 h-14 sm:w-20 sm:h-20 rounded-full bg-sky-400 text-[#0B192C] flex items-center justify-center shadow-2xl shadow-sky-400/30 transition-transform duration-300 group-hover:scale-110">
                <Play size={22} fill="currentColor" className="ml-1 sm:hidden" />
                <Play size={30} fill="currentColor" className="ml-1 hidden sm:block" />
              </span>
            </span>
            <span className="absolute bottom-0 left-0 right-0 p-4 sm:p-8">
              <span className="font-display font-bold text-white text-sm sm:text-xl block">{PRESENTATION.title}</span>
              <span className="text-sky-300 text-xs sm:text-sm font-mono-accent tracking-wider">{PRESENTATION.duration} · worth every minute</span>
            </span>
          </button>
        )}
      </div>
    </motion.div>
  );
}

function StoryCard({ video, i }) {
  const [playing, setPlaying] = useState(false);
  return (
    <div className="relative shrink-0 w-[160px] sm:w-[180px] snap-start rounded-2xl overflow-hidden border border-white/10 bg-white/[0.04]" data-testid={`story-card-${i}`}>
      <div className="relative w-full" style={{ paddingTop: "177.78%" }}>
        {playing ? (
          <iframe
            src={embedUrl(video, true)}
            title={video.title}
            className="absolute inset-0 w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            data-testid={`story-iframe-${i}`}
          />
        ) : (
          <button
            type="button"
            onClick={() => { setPlaying(true); window.__track?.("testimonial_play"); }}
            className="group absolute inset-0 w-full h-full"
            data-testid={`story-play-${i}`}
            aria-label={`Play ${video.title}`}
          >
            <img src={video.thumb} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
            <span className="absolute inset-0 bg-gradient-to-t from-[#0B192C]/90 via-transparent to-[#0B192C]/30" />
            <span className="absolute inset-0 flex items-center justify-center">
              <span className="w-11 h-11 rounded-full bg-sky-400/95 text-[#0B192C] flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                <Play size={16} fill="currentColor" className="ml-0.5" />
              </span>
            </span>
            <span className="absolute bottom-0 left-0 right-0 p-3 text-left">
              <span className="text-white text-xs font-semibold leading-snug block">{video.title}</span>
              <span className="text-sky-300/90 text-[10px] font-mono-accent tracking-wider">{video.duration}</span>
            </span>
          </button>
        )}
      </div>
    </div>
  );
}

export default function VideoWall() {
  return (
    <section id="videos" className="bg-[#0B192C] py-24 md:py-36 scroll-mt-20" data-testid="video-wall-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <motion.p variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }} custom={0}
          className="font-mono-accent text-xs uppercase tracking-[0.28em] text-sky-400 mb-6">
          Watch &amp; decide
        </motion.p>
        <motion.h2 variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }} custom={1}
          className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-white max-w-2xl leading-[1.1] mb-6">
          The full picture — then hear it from real associates.
        </motion.h2>
        <motion.p variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }} custom={1}
          className="text-slate-400 max-w-xl leading-relaxed mb-14">
          No forms, no gates. The complete presentation is right here — followed by short,
          unscripted stories from people building this business alongside their lives.
        </motion.p>

        <FeaturedPlayer />

        <motion.p variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }} custom={0}
          className="font-mono-accent text-xs uppercase tracking-[0.28em] text-sky-400 mb-6">
          Hear from real associates
        </motion.p>
        <div className="flex gap-4 overflow-x-auto pb-4 snap-x snap-mandatory -mx-4 px-4 sm:mx-0 sm:px-0" data-testid="story-row">
          {STORIES.map((v, i) => <StoryCard key={v.id} video={v} i={i} />)}
        </div>
        <p className="text-slate-500 text-xs mt-3 sm:hidden">Swipe to see more →</p>

        <p className="text-[11px] text-slate-500 leading-relaxed mt-10 max-w-2xl" data-testid="video-wall-disclaimer">
          Real associates sharing their own experiences, featured on the company's official
          associate pages. Associates are independent contractors — results vary with effort,
          and no income is promised or guaranteed.
        </p>
      </div>
    </section>
  );
}
